import { useQuery } from '@tanstack/react-query';

import { usePermissions } from '../../../utils/hooks/usePermissions';
import { queryKeys } from '../../react-query/queryKeys';
import { getAllArticlesByCategory, GetAllArticlesByCategoryProps } from '../researchHubContent';

export default function useFetchAllArticlesByCategory(
  props: GetAllArticlesByCategoryProps,
  enabled: boolean
) {
  // Resolved here rather than at the five call sites, so none of them can omit it.
  const { hasPermission } = usePermissions();
  const hasResearchListAccess = hasPermission('research_hub:research_list');
  const hasSubscriberOnlyAccess = hasPermission('research_hub:subscriber_only');

  return useQuery({
    // Both flags are in the key: the server decides what a row contains, so two callers on
    // different plans must never share a cache entry.
    queryKey: queryKeys.insightsHub.byCategory(
      props.category,
      props.projectTypes,
      hasSubscriberOnlyAccess,
      hasResearchListAccess
    ),
    queryFn: () => getAllArticlesByCategory({ ...props, hasResearchListAccess }),
    enabled,
  });
}
